import { getSessionCookie } from './cookies';

// CE-3737: quando o Gerador, Transportador ou Destino Final selecionado está Vencido ou Inativo,
// a API libera o acesso apenas para consulta e emissão de relatórios (campo SomenteConsulta
// devolvido em /acesso e no login). Aqui o front reflete essa restrição na interface.

// Rotas que continuam editáveis mesmo em modo consulta: o cadastro é justamente o que o
// usuário precisa alterar para regularizar a situação e voltar a operar.
export const rotasLiberadasEmConsulta = [
    "Cadastros.MeuCadastro",
    "Cadastros.MeuCadastroGerador",
];

// Indica se o acesso selecionado na sessão está restrito a consulta.
export const isSomenteConsulta = () => {
    const session = getSessionCookie();
    return session?.acesso?.somenteConsulta === true;
};

// Rebaixa a permissão da tela para "Visualizar" quando o acesso está restrito a consulta,
// preservando as telas de "Meu Cadastro". Como todas as telas do admin já decidem exibir as
// ações de escrita por permissao === "Editar", rebaixar aqui desabilita a escrita em todo o
// módulo de uma só vez, sem depender de ajuste tela por tela.
export const permissaoEmModoConsulta = (permissao, codigoFuncionalidade) => {
    if (!isSomenteConsulta())
        return permissao;

    if (rotasLiberadasEmConsulta.includes(codigoFuncionalidade))
        return permissao;

    return permissao === "Editar" ? "Visualizar" : permissao;
};
